// Close button and label on mobile subnavigation
jQuery(function() {
    jQuery("li.sub-menu-close").click(function () {
      if (jQuery(window).outerWidth() <= 767) {
        jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-closed");
        jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-open");
        jQuery("#page-title-area").toggleClass("sidebar-is-closed");
        jQuery("#page-title-area").toggleClass("sidebar-is-open");
        jQuery(".layout-content").toggleClass("sidebar-is-closed");
        jQuery(".layout-content").toggleClass("sidebar-is-open");
      }
    });
    jQuery(".dol-subnav-wrapper li.sub-menu-close a").click(function(e) {
      e.preventDefault();
    });
    jQuery(".dol-subnav-wrapper label").click(function () {
        if (jQuery(window).outerWidth() <= 767) {
          jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-closed");
          jQuery(".dol-subnav-wrapper").toggleClass("sidebar-is-open");
          jQuery("#page-title-area").toggleClass("sidebar-is-closed");
          jQuery("#page-title-area").toggleClass("sidebar-is-open");
          jQuery(".layout-content").toggleClass("sidebar-is-closed");
          jQuery(".layout-content").toggleClass("sidebar-is-open");
        }
    });
});
// Shows full subnavigation over 768px window width
jQuery(function() {
  if(jQuery(window).outerWidth() >= 768) {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');
  }
  else {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
  }
  jQuery(window).on('resize', function(){
      if(jQuery(window).outerWidth() > 767) {
          jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
          jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');
          jQuery('#page-title-area').removeClass('sidebar-is-open');
          jQuery('.layout-content').removeClass('sidebar-is-open');
      }
      else {
          jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
          jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
          jQuery('#page-title-area').removeClass('sidebar-is-open');
          jQuery('.layout-content').removeClass('sidebar-is-open');
      }
  });
  jQuery('.dol-sidebar').click(function(event) {
    event.stopPropagation();
  });
});

// Assigns active class to current page's link in subnavigation
jQuery(document).ready(function() {
    var pathname = window.location.pathname;
    jQuery('ul.usa-sidenav li a[href="'+pathname+'"]').addClass('usa-current');
});

// Adds bootstrap class for sidebar
jQuery(document).ready(function () {
    if (jQuery('.cd-main-content').find('.dol-subnav-wrapper').length > 0) {
        jQuery('.cd-main-content').addClass('active-book-page');
        // jQuery('.left-sidebar').addClass('col-md-3');
    }
    if (jQuery('.cd-main-content').find('.groups-sidebar').length > 0) {
        jQuery('.cd-main-content').addClass('groups-sidebar');
        // jQuery('.left-sidebar').addClass('col-md-3');
    }
  });

  // Book Navigation - Display of parent and grandchild pages so that only the grandchild and parent page are highlighted.
(function ($) {
  $(document).ready(function () {
    // Declare and initialize the level to 0.
    var level = 0;

    // Get a list of the Book navigation structure.
    var $list = $('ul[block="block-dol-booknavigation"]');
    // Check if the list is set to proceed with traversing it.
    if($list.length > 0){
      // Go through the book navigation structure.
      traverseBookNavigation($list, level);
    }

    // Recursive function to traverse the book navigation.
    function traverseBookNavigation($list, level) {
      if ($list.length > 0) {
        // Get all the list items from the list to check if they are part of the active trail.
        $list.children('li').each(function () {
          // Follow the trail if the current list item is part of the active trail.
          if ($(this).hasClass("is-current")) {
            // Proceed to find children of the active trail only if it is not the first level and have unordered list as children.
            if (level > 0 && $(this).children('ul').length > 0) {
              var hasCurrent = false;
              $(this).children('ul').each(function () {
                // Check every children unordered list and its list items if they  are part of the active trail.
                $(this).children('li').each(function () {
                  if ($(this).hasClass("is-current")) {
                    hasCurrent = true;
                  }
                });
              });
              // Check to see if the lit item link has an active trail as child and if it does remove the active trail css classes.
              if(hasCurrent == true){
                // Remove the active trail class on the list item.
                $(this).removeClass("is-current");
                // Remove the active trail class on link inside the list item.
                $(this).children('a'). removeClass("usa-current");
              }
            }
            if ($(this).children('ul')) {
              // Recursively call itself in case the the structure has an un ordered list as a child.
              traverseBookNavigation($(this).children('ul'), level + 1);
            }
          }
        });
      }
    }
  });
})(jQuery);